<template>
    <div>
        <a-modal 
            v-model:open="props.visible"
            :title="$t('menu.FirmwareRelease')"
            :width="900"
            centered
            :confirmLoading="btn_loading"
            :destroyOnClose="true"
            @ok="handleUpLoadFirmware"
            @cancel="handleCancel"
        >
            <a-divider></a-divider>
            <div class="form_item">
                <div class="form_item_left">
                    <div class="form_item_label required">{{ $t('firmware.environment') }}</div>
                    <a-select 
                        class="query_field form_item" 
                        v-model:value="addFormData.environment" 
                        allowClear
                        showSearch
                        disabled
                        :options="environmentOptions" 
                        @change="(val)=>handleSelectChange(val,'environment')"
                    ></a-select>
                </div>
                <div class="form_item_right">
                    <div class="form_item_label required">{{ $t('firmware.release_limit') }}</div>
                    <a-select 
                        class="query_field form_item" 
                        style="margin-right: 0;"
                        v-model:value="addFormData.release_limit" 
                        allowClear
                        showSearch
                        :disabled="props.isEdit"
                        :options="releaseLimitOptions" 
                        @change="(val)=>handleSelectChange(val,'release_limit')"
                    ></a-select>
                </div>
            </div>

            <div class="form_item2">
                <div class="form_item_label" :class="{'required': addFormData.release_limit != 0}">{{ $t('firmware.release_limit_val') }}</div>
                <a-select 
                    v-if="addFormData.release_limit != 4 && addFormData.release_limit != 5 && addFormData.release_limit != 6"
                    class="query_field form_item2"
                    v-model:value="addFormData.release_limit_val" 
                    allowClear
                    showSearch
                    mode="multiple"
                    :max-tag-count="2"
                    :disabled="addFormData.release_limit == 0"
                    :options="releaseLimitValOptions" 
                    @change="(val)=>handleSelectChange(val,'release_limit_val')"
                ></a-select>
                <a-select
                    v-if="addFormData.release_limit == 4 || addFormData.release_limit == 5|| addFormData.release_limit == 6"
                    v-model:value="addFormData.release_limit_val"
                    mode="multiple"
                    label-in-value
                    :placeholder="t('firmware.supportFuzzySearch')"
                    style="width: 100%"
                    allowClear
                    :filter-option="false"
                    :not-found-content="fetching? undefined : null"
                    :options="releaseLimitValOptions"
                    @search="(val) => handleInputChange(val)"
                    @change="(val)=>handleSelectChange(val,'release_limit_val')"
                >
                    <template v-if="fetching" #notFoundContent>
                        <a-spin size="small" />
                    </template>
                </a-select>
            </div>
            
            <!-- <a-upload
                v-if="!props.isEdit"
                v-model:file-list="fileList"
                accept=".bin"
                name="file"
                :max-count="1"
                :customRequest="customRequest"
                @change="uploadChange"
                @remove="uploadRemove"
            >
                <a-button class="form_item" type="primary">
                    <upload-outlined></upload-outlined>
                    {{ $t('firmware.file') }}
                </a-button>
            </a-upload> -->

        <!-- 表格迁移到外部 -->
        <!-- <a-input v-model:value="formData.project_no" allowClear :placeholder="t('firmware.project_no')" style="width: 150px; margin: 0 10px 5px 0" @change="handleFormInputChange('project_no')"/>
        <a-input v-model:value="formData.part_no" allowClear :placeholder="t('firmware.part_no')" style="width: 150px; margin: 0 10px 5px 0" @change="handleFormInputChange('part_no')"/>
        <a-input v-model:value="formData.hardware_version" allowClear :placeholder="t('firmware.hardware_version')" style="width: 150px; margin: 0 10px 5px 0" @change="handleFormInputChange('hardware_version')"/>
        <a-input v-model:value="formData.software_version" allowClear :placeholder="t('firmware.software_version')" style="width: 150px; margin: 0 10px 5px 0" @change="handleFormInputChange('software_version')"/>
        
        <div>
            <Table
                class="table"
                :table="table"
                @handleChangePagination="handleChangePagination"
                @onSelectChange="onSelectChange"
            >
            
            </Table>    
        </div> -->
        <div class="form_item">
                <div class="form_item_left">
                    <div class="form_item_label">{{ $t('firmware.hardware_name') }}</div>
                    <div class="query_field form_item" >{{ selectItem.file_name }}</div>
                </div>
                
            </div>


            <a-divider>{{ $t('firmware.description') }}</a-divider>
            <div style="margin-bottom: 40px; height:400px; overflow-y: scroll;">
                <div class="form_item_label required">{{ t('firmware.firmware_description') }}</div>
                <a-textarea
                    class="mb10"
                    v-model:value="addFormData.firmware_desc"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="800"
                    showCount
                />
                <div class="form_item_label required">{{ t('firmware.firmware_description_de') }}</div>
                <a-textarea
                    class="mb10"
                    v-model:value="addFormData.firmware_desc_de"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="800"
                    showCount
                />
                <div class="form_item_label required">{{ t('firmware.firmware_description_fr') }}</div>
                <a-textarea
                    class="mb10"
                    v-model:value="addFormData.firmware_desc_fr"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="800"
                    showCount
                />
                <div class="form_item_label">{{ t('firmware.firmware_description_nl') }}</div>
                <a-textarea
                    v-model:value="addFormData.firmware_desc_nl"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="800"
                    showCount
                />
                <div class="form_item_label">{{ t('firmware.firmware_description_et') }}</div>
                <a-textarea
                    v-model:value="addFormData.firmware_desc_et"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="800"
                    showCount
                />
                <div class="form_item_label">{{ t('firmware.firmware_description_lv') }}</div>
                <a-textarea
                    v-model:value="addFormData.firmware_desc_lv"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="800"
                    showCount
                />
                <div class="form_item_label">{{ t('firmware.firmware_description_lt') }}</div>
                <a-textarea
                    v-model:value="addFormData.firmware_desc_lt"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :maxlength="800"
                    showCount
                />
            </div>
            
        </a-modal>
    </div>  
</template>

<script setup>
    import { ref, reactive, onMounted, watch, computed } from "vue";
    import { message, Modal, notification } from 'ant-design-vue';
    import { useI18n } from 'vue-i18n';
    import Table from "@/components/Table.vue";
    import { FirmwareApi } from '@/api/FirmwareApi.js';
    const { t } = useI18n()

    const emits = defineEmits([
        'handleInputChange',
        'handleSearch',
        'handleSelectChange',
        'handleCancel',
    ])

    const props = defineProps({
        visible:{
            type:Boolean,
        },
        isEdit:{
            type:Boolean,
        },
        rowData:{
            type:Object,
            default:()=>{},
        },
        selectItem:{
            type: Object,
            default:()=>{},
        },
    })

    // const visible = ref(false)
    const btn_loading = ref(false)
    const fetching = ref(false)
    const fileList = ref([])

    const addFormData = reactive({
        environment: null,
        release_limit: null,
        release_limit_val:[],
        firmware_desc:'',
        firmware_desc_de:'',
        firmware_desc_fr:'',
        firmware_desc_nl:'',
        firmware_desc_et:'',
        firmware_desc_lv:'',
        firmware_desc_lt:'',
        file:'',
    })

    const formData = reactive({
        project_no: '',
        part_no: '',
        hardware_version: '',
        software_version: '',
    })

    const state = reactive({   
        selectedRowKeys: [], // Check here to configure the default column
        loading: false,
    });
    const hasSelected = computed(() => state.selectedRowKeys.length > 0);

    const table = ref({
        data: [],
        columns: [
            {
                title: t('base.id'),//'租户'
                key: 'id',
                dataIndex: 'id',
                width: 110,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('firmware.project_no'),//'项目编号'
                dataIndex: 'project_no',
                key: 'project_no',
                width: 110,
                resizable: true,
            },
            {
                title: t('firmware.company_id'),//'公司ID'
                dataIndex: 'company_id',
                key: 'company_id',
                width: 120,
                resizable: true,
            },
            {
                title: t('firmware.part_no'),//'部件编号'
                dataIndex: 'part_no',
                key: 'part_no',
                width: 100,
                ellipsis: true,
                resizable: true,
            },
            {
                title: t('firmware.hardware_version'),//'硬件版本'
                dataIndex: 'hardware_version',
                key: 'hardware_version',
                width: 150,
                resizable: true,
            },
            {
                title: t('firmware.software_version'),//'软件版本'
                dataIndex: 'software_version',
                key: 'software_version',
                width: 150,
                ellipsis: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1800,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: true,
            rowSelectionType: 'radio',
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })


    const environmentOptions = ref([
        { label: t('firmware.market_environment'), value: '0' },
        // { label: t('firmware.testing_environment'), value: '1' },
        // { label: t('firmware.production_environment'), value: '2' },
    ])
    const releaseLimitOptions = ref([
        { label: t('firmware.unlimited'), value: '0', disabled: false },
        // { label: t('firmware.base'), value: '1', disabled: false },
        // { label: t('firmware.grayscale'), value: '2', disabled: false },
        { label: t('firmware.personal'), value: '3', disabled: false },
        { label: t('firmware.frameNumber'), value: '5', disabled: false },
        { label: t('firmware.assemblyCode'), value: '4', disabled: false },
        { label: t('firmware.sku'), value: '6', disabled: false },
    ])
    const releaseLimitValOptions = ref([])

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys, selectedRows);
        state.selectedRowKeys = selectedRowKeys;
    };
    const handleSelectChange = (val, key) => {
        switch(key){
            case 'environment':
                addFormData.release_limit = '0'
                addFormData.release_limit_val = []
                setOptions()
                break
            case 'release_limit':
                addFormData.release_limit_val = []
                releaseLimitValOptions.value = []
                console.log(addFormData.release_limit,'release_limit')

                if(addFormData.release_limit == '1'){
                    getBaseQuery()
                }else if(addFormData.release_limit == '2'){
                    getGrayscale()
                }else if(addFormData.release_limit == '3'){
                    getUserQuery()
                }
                setOptions()
                break
            case 'release_limit_val':
                console.log(val,'valllll')
                addFormData.release_limit_val = []

                if(addFormData.release_limit == '4' || addFormData.release_limit == '5' || addFormData.release_limit == '6'){
                    val.forEach(item => {
                        addFormData.release_limit_val.push(item.value)
                    })
                }else{
                    addFormData.release_limit_val = val
                }
               
                console.log(addFormData.release_limit_val,'addFormData.release_limit_val 444444')
                break
        }
    }

    const setOptions = () => {
        releaseLimitOptions.value.forEach(item => {
            if(item.value == '1'){
                item.disabled = addFormData.environment == '1' || addFormData.environment == '0'
            }else if(item.value == '2'){
                item.disabled = addFormData.environment == '1' || addFormData.environment == '2'
            }else if(item.value == '3'){
                item.disabled = addFormData.environment == '2'
            }else if(item.value == '4'){
                item.disabled = addFormData.environment == '2'
            }else if(item.value == '5'){
                item.disabled = addFormData.environment == '2'
            }
        })
    }

    const handleInputChange = (val) => {
        console.log(val,'valll', addFormData.release_limit)
        if(addFormData.release_limit == '5'){
            getFrameNumber(val)
        }else if(addFormData.release_limit == '4'){
            getAssemblyCode(val)
        }else if(addFormData.release_limit == '6'){
            getSkuLists(val)
        }
    }

    

    // 获取固件列表
    const getList = async() => {
        let param = {
            page_num: table.value.configs.pagination.current,
            page_size: table.value.configs.pagination.pageSize,
            project_no: formData.project_no.trim() || '',
            part_no: formData.part_no.trim() || '',
            hardware_version: formData.hardware_version.trim() || '',
            software_version: formData.software_version.trim() || '',
        }

        table.value.configs.loading = true
        let res = await FirmwareApi.getInstance().getFirmwareFileList(param)
        if (res.code == 0) {
            let data = res.data
            
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            table.value.configs.loading = false
        } else {
            message.error(res.msg);
        }
    }

    const handleFormInputChange = (formData) => {
        table.value.configs.pagination.current = 1
        getList()
    }

    // 分页
    const handleChangePagination = (config, data) => {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }
    // 自定义上传请求，不实际提交到服务器
    const customRequest = (options) => {
        const { file, onSuccess, onError } = options;
        
        // 模拟上传成功，直接调用 onSuccess
        setTimeout(() => {
            onSuccess({ status: 'done' }, file);
        }, 100);
    }

    // 上传文件
    const uploadChange = (obj)=>{
        console.log(obj,'obj')
        addFormData.file = obj.file.originFileObj
    }

    // 移除文件
    const uploadRemove = ()=>{
        addFormData.file = ''
        fileList.value = []
    }

    // 固件确认上传校验
    const vaildUpload = () => {
        if(props.isEdit){ // 编辑
            if (addFormData.release_limit != '0' && addFormData.release_limit_val.length === 0) {
                message.error(t('firmware.limitValMsg'))
                return false
            } else if (!addFormData.firmware_desc) {
                message.error(t('firmware.firmwareDescMsg'))
                return false
            } else if (!addFormData.firmware_desc_de) {
                message.error(t('firmware.firmwareDescDeMsg'))
                return false
            } else if (!addFormData.firmware_desc_fr) {
                message.error(t('firmware.firmwareDescFrMsg'))
                return false
            } else if (!addFormData.firmware_desc_nl) {
                message.error(t('firmware.firmwareDescNLMsg'))
                return false
            } 
            else if (!addFormData.firmware_desc_et) {
                message.error(t('firmware.firmwareDescEtMsg'))
                return false
            } else if (!addFormData.firmware_desc_lv) {
                message.error(t('firmware.firmwareDescLvMsg'))
                return false
            } else if (!addFormData.firmware_desc_lt) {
                message.error(t('firmware.firmwareDescLtMsg'))
                return false
            }
        }else{ // 新增
            if (addFormData.environment === '' || addFormData.environment === undefined) {
                message.error(t('firmware.releaseMsg'))
                return false
            } else if (addFormData.release_limit === '' || addFormData.release_limit === undefined) {
                message.error(t('firmware.limitMsg'))
                return false
            } else if (addFormData.release_limit != '0' && addFormData.release_limit_val.length === 0) {
                message.error(t('firmware.limitValMsg'))
                return false
            } 
            // else if (!addFormData.file) {
            //     message.error(t('firmware.fileMsg'))
            //     return false
            // } 
            else if (!addFormData.firmware_desc) {
                message.error(t('firmware.firmwareDescMsg'))
                return false
            } else if (!addFormData.firmware_desc_de) {
                message.error(t('firmware.firmwareDescDeMsg'))
                return false
            } else if (!addFormData.firmware_desc_fr) {
                message.error(t('firmware.firmwareDescFrMsg'))
                return false
            } 
            // else if (!addFormData.firmware_desc_nl) {
            //     message.error(t('firmware.firmwareDescNLMsg'))
            //     return false     
            // } 
            // else if (!addFormData.firmware_desc_et) {
            //     message.error(t('firmware.firmwareDescEtMsg'))
            //     return false
            // } 
            // else if (!addFormData.firmware_desc_lv) {
            //     message.error(t('firmware.firmwareDescLvMsg'))
            //     return false
            // } 
            // else if (!addFormData.firmware_desc_lt) {
            //     message.error(t('firmware.firmwareDescLtMsg'))
            //     return false
            // }
        }

        return true
    }

    // 确认上传固件
    const handleUpLoadFirmware = async () => {
        if (!vaildUpload()) return
        console.log('addFormData.release_limit_val',addFormData.release_limit_val)
        btn_loading.value = true
        if(props.isEdit){ // 编辑
            editLimit()
        }else{ // 新增
            // let form = new FormData();
            // form.append('file', addFormData.file)
            let res = await FirmwareApi.getInstance().uploadPublishFirmware(props.selectItem.id,{
                release_limit: addFormData.release_limit || '',
                release_limit_val: addFormData.release_limit_val.join(';') || '',
                firmware_desc: addFormData.firmware_desc || '',
                firmware_desc_de: addFormData.firmware_desc || '',
                firmware_desc_fr: addFormData.firmware_desc_fr || '',
                firmware_desc_nl: addFormData.firmware_desc_nl || '',
                firmware_desc_et: addFormData.firmware_desc_et || '',
                firmware_desc_lv: addFormData.firmware_desc_lv || '',
                firmware_desc_lt: addFormData.firmware_desc_lt || '',
            }
                
            )
            if (res.code == 0) {
                message.success(t('firmware.uploadMsg'))
                btn_loading.value = false
                emits('handleCancel')
            } else {
                message.error(res.msg)
                btn_loading.value = false
            }
        }

        
    }

    const handleCancel = () => {
        emits('handleCancel')
    }

    // 编辑固件上传
    const editLimit = async ()=>{
        let param = {
            firmware_desc: addFormData.firmware_desc,
            firmware_desc_de: addFormData.firmware_desc_de,
            firmware_desc_fr: addFormData.firmware_desc_fr,
            firmware_desc_nl: addFormData.firmware_desc_nl,
            firmware_desc_et: addFormData.firmware_desc_et,
            firmware_desc_lv: addFormData.firmware_desc_lv,
            firmware_desc_lt: addFormData.firmware_desc_lt,
        }

        console.log(addFormData.release_limit_val,'addFormData.release_limit_val')
        if(addFormData.release_limit !== 0) param.limit_val = addFormData.release_limit_val

        btn_loading.value = true
        let res = await FirmwareApi.getInstance().editLimit(param, props.rowData.id)
        if (res.code == 0) {
            message.success(t('base.editSuccessMsg'))
            btn_loading.value = false
            emits('handleCancel')
        } else {
            message.error(res.msg)
            btn_loading.value = false
        }
    }

    // 获取基地的限制具体指
    const getBaseQuery = async () => {
        let res = await FirmwareApi.getInstance().getBaseQuery()
        if (res.code == 0) {
            releaseLimitValOptions.value = res.data.map(i => {
                return {
                    label: i.manufacture_base,
                    value: i.manufacture_base
                }
            })
        } else {
            message.error(res.msg)
        }
    }

    // 获取灰度的限制具体指
    const getGrayscale = async () => {
        let res = await FirmwareApi.getInstance().getGrayscale()
        if (res.code == 0) {
            releaseLimitValOptions.value = res.data.map(i => {
                return {
                    label: i.range_name,
                    value: i.range_name
                }
            })
        } else {
            message.error(res.msg)
        }
    }

    // 获取个人的限制具体指
    const getUserQuery = async () => {
        let res = await FirmwareApi.getInstance().getUserQuery()
        if (res.code == 0) {
            releaseLimitValOptions.value = res.data.map(i => {
                return {
                    label: i.email,
                    value: i.user_id,
                }
            })
        } else {
            message.error(res.msg)
        }
    }

    // 获取车架号的限制具体值
    const getFrameNumber = async (keyword) => {
        let param= {
            frame_number: keyword
        }
        fetching.value = true
        let res = await FirmwareApi.getInstance().getFrameNumberOrAssemblyCode(param, 1, 20)
        if (res.code == 0) {
            fetching.value = false
            releaseLimitValOptions.value = []
            res.data.records.forEach(i => {
                if(i.frame_number){ 
                    releaseLimitValOptions.value.push({
                        label: i.frame_number,
                        value: i.frame_number,
                    }) 
                }
            })
        } else {
            message.error(res.msg)
        }
    }

    // 获取车架号的限制具体值
    const getSkuLists = async (keyword) => {
        fetching.value = true
        let res = await FirmwareApi.getInstance().getSkuCode({
            sku: keyword,
            page_num: 1,
            page_size: 20
        },1,20)
        if (res.code == 0) {
            fetching.value = false
            releaseLimitValOptions.value = []
            res.data.forEach(i => {
                if(i){ 
                    releaseLimitValOptions.value.push({
                        label: i,
                        value: i,
                    }) 
                }
            })
        } else {
            message.error(res.msg)
        }
    }

    // 获取总成编码的限制具体值
    const getAssemblyCode = async (keyword) => {
        let param= {
            triple_id: keyword
        }
        fetching.value = true
        let res = await FirmwareApi.getInstance().getFrameNumberOrAssemblyCode(param, 1, 20)
        if (res.code == 0) {
            fetching.value = false
            releaseLimitValOptions.value = []
            res.data.records.forEach(i => {
                if(i.triple_id){
                    releaseLimitValOptions.value.push({
                        label: i.triple_id,
                        value: i.triple_id,
                    }) 
                }
            })
        } else {
            message.error(res.msg)
        }
    }

    // resetForm
    const resetForm = () => {
        for(let key in addFormData){
            if(key == 'environment'){
                addFormData[key] = '0'
            }else if(key == 'release_limit'){
                addFormData[key] = '0'
            }else if(key == 'release_limit_val'){
                addFormData[key] = []
            }else{
                addFormData[key] = ''
            }
            
        }
        fileList.value = []
        btn_loading.value = false
    }


    watch(()=>props.visible, (newVal) => {
        console.log(newVal,'newVal 222', props.rowData)
        resetForm()
        if(props.isEdit){
            releaseLimitValOptions.value = []
            if(props.rowData.release_limit_data == '1'){
                getBaseQuery()
            }else if(props.rowData.release_limit_data == '2'){
                getGrayscale()
            }else if(props.rowData.release_limit_data == '3'){
                getUserQuery()
            }
                
            setOptions()

            addFormData.environment = '0'
            addFormData.release_limit = `${props.rowData.release_limit_data}`
            addFormData.release_limit_val = []
            addFormData.release_limit_val = props.rowData.release_limit_data === 0 || props.rowData.release_limit_val == '-' || props.rowData.release_limit_val === ''? [] : props.rowData.release_limit_val.split(';')
            addFormData.firmware_desc = props.rowData.file_desc
            addFormData.firmware_desc_de = props.rowData.file_desc_de
            addFormData.firmware_desc_fr = props.rowData.file_desc_fr
            addFormData.firmware_desc_nl = props.rowData.file_desc_nl
            addFormData.firmware_desc_et = props.rowData.file_desc_et
            addFormData.firmware_desc_lv = props.rowData.file_desc_lv
            addFormData.firmware_desc_lt = props.rowData.file_desc_lt

        }
    })

    defineExpose({
        addFormData
    })
    
    onMounted(() => {
        if(!props.isEdit){
            resetForm()
        }

        setOptions()
        getList()
    })

</script>

<style lang="scss" scoped>

.form_item{
    display: flex;
    margin-bottom: 10px;
    
    .form_item_left{
        flex: 1;
        margin-right: 10px;
    }

    .form_item_right{
        flex: 1;
    }
}

.form_item2{
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

.form_item_label{
    margin-bottom: 5px;
    font-size: 13px;
    font-weight: 500;
}

.required::after{
    content: '*';
    color: red;
    margin-left:2px;
}

.mb10{
    margin-bottom: 10px;
}

</style>